<template>
    <FormSelect
        v-bind="$attrs"
        :label="label"
        @input="$emit('input', $event)"
        :nullable="true"
        :value="value"
        :required="required"
    >
        <option v-for="state in usaStates" :key="state" :value="state">{{ state }}</option>
    </FormSelect>
</template>

<script>
import UsaStates from 'usa-states';

const usaStates = new UsaStates.UsaStates().states.map(state => state.abbreviation);

export default {
    name: 'FormSelectStateV2',
    inheritAttrs: false,

    props: {
        value: { type: String },
        label: { type: String, default: 'State' },
        required: { type: Boolean, default: false },
    },

    data: () => ({ usaStates }),
};
</script>
